<script>
import Icon from '@wielink-application/shared/vue/components/form/input-only/icon.vue'
export default Icon;
</script>